import React from "react";
import { ArrowUpRight, ArrowDownRight } from "@phosphor-icons/react";
import { inr, num } from "./iaUtils";

const CARDS = [
  { k: "sr_created", label: "SRs created", fmt: num },
  { k: "sr_completed", label: "SRs completed", fmt: num, sub: (t) => `${t.completion_rate}% completion` },
  { k: "inv_generated", label: "Invoices generated", fmt: num, sub: (t) => inr(t.inv_generated_amt) },
  { k: "inv_paid", label: "Invoices paid", fmt: num, sub: (t) => inr(t.inv_paid_amt) },
  { k: "billed", label: "Total billed", fmt: inr },
  { k: "collected", label: "Total collected", fmt: inr, tone: "text-[#2D5A27]" },
  { k: "outstanding", label: "Outstanding", fmt: inr, tone: "text-[#B42828]", lowerIsBetter: true },
  { k: "prepaid", label: "Prepaid", fmt: inr },
  { k: "health_created", label: "Health bookings", fmt: num, sub: (t) => `${num(t.health_completed)} completed` },
  { k: "health_collected", label: "Health collected", fmt: inr },
  { k: "avg_invoice", label: "Avg invoice value", fmt: inr },
  { k: "avg_days_to_pay", label: "Avg days to pay", fmt: (v) => (v == null ? "—" : `${v} d`), lowerIsBetter: true },
];

function Delta({ cur, prev, lowerIsBetter }) {
  if (prev == null || cur == null) return null;
  if (!prev) return cur ? <span className="text-[10px] text-[#8A8780]">new vs prev.</span> : null;
  const pct = Math.round(((cur - prev) / Math.abs(prev)) * 100);
  if (pct === 0) return <span className="text-[10px] text-[#8A8780]">no change</span>;
  const good = lowerIsBetter ? pct < 0 : pct > 0;
  const Icon = pct > 0 ? ArrowUpRight : ArrowDownRight;
  return (
    <span className={`inline-flex items-center text-[10px] font-semibold ${good ? "text-[#2D5A27]" : "text-[#B42828]"}`}>
      <Icon size={11} weight="bold"/>{Math.abs(pct)}% vs prev.
    </span>
  );
}

export function SummaryCards({ totals, previous }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-3" data-testid="ia-cards">
      {CARDS.map((c, i) => (
        <div key={c.k} data-testid={`ia-card-${c.k}`} style={{ animationDelay: `${i * 30}ms` }}
             className="ia-rise bg-white border border-[#E5E2D9] rounded-md p-3 hover:shadow-sm transition-shadow">
          <div className="text-[10px] uppercase tracking-[0.16em] text-[#8A8780]">{c.label}</div>
          <div className={`font-heading text-xl mt-1 ${c.tone || "text-[#1A1A1A]"}`} data-testid={`ia-card-${c.k}-value`}>{c.fmt(totals[c.k])}</div>
          {c.sub && <div className="text-[11px] text-[#5C5A55]">{c.sub(totals)}</div>}
          <Delta cur={totals[c.k]} prev={previous?.[c.k]} lowerIsBetter={c.lowerIsBetter}/>
        </div>
      ))}
    </div>
  );
}
